import React, { Component } from 'react';
import { defineMessages, T, t } from '@sm/intl';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Align,
  Grid,
  Row,
  Col,
  Icon,
  Button,
} from '@sm/wds-react';
import SessionCtrl from './SessionCtrl';

import './session-timeout-modal.scss';

const COPY = defineMessages({
  CONTINUE_SESSION: {
    id: 'SessionTimeoutModal.ContinueSession',
    defaultMessage: 'CONTINUE SESSION',
    description:
      '[Type: Button][Vis.: med] - CTA for the user to continue their browsing session and not be logged out automatically.',
  },
  TIME_LEFT_MSG: {
    id: 'SessionTimeoutModal.TimeLeftMessage',
    defaultMessage:
      'After {minutesLeft, plural, one { 1 minute } other {{ minutesLeft } minutes}} of inactivity, we sign you out to keep your data safe. Your session will expire soon, unless you click <i>Continue Session</i>',
    description:
      '[Type: Paragraph][Vis.: med] - Message given to the user informing them of the time left before automatic expiration.',
  },
  SESSION_HEADER: {
    id: 'SessionTimeoutModal.TimeLeftHeader',
    defaultMessage: 'Do you want to continue your session?',
    description:
      '[Type: Header][Vis.: med] - Modal header for the prompt asking the user if they want to continue their browsing session.',
  },
});

class SessionTimeoutModal extends Component {
  static propTypes = {
    user: PropTypes.shape({
      hipaa: PropTypes.shape({
        isHipaaEnabled: PropTypes.bool,
      }),
      group: PropTypes.shape({
        sessionTimeout: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),
      }),
    }).isRequired,
  };

  state = {
    show: false,
    timeLeft: null,
  };

  componentDidMount() {
    const { user } = this.props;
    const timeout =
      user &&
      ((user.hipaa && user.hipaa.isHipaaEnabled && 30 * 60) ||
        (user.group &&
          user.group.sessionTimeout &&
          parseInt(user.group.sessionTimeout, 10) * 60));
    if (timeout !== undefined) {
      // it could be 0
      SessionCtrl.init({ timeout, reminderCb: this.onReminder });
    }
  }

  componentWillUnmount() {
    SessionCtrl.removeCallback();
  }

  onReminder = timeLeft => {
    this.setState({ show: true, timeLeft });
  };

  onClose = () => {
    SessionCtrl.continueSession(() => {
      this.setState({ show: false, timeLeft: 0 });
    });
  };

  render() {
    const timeLeft = Math.ceil(this.state.timeLeft / 60);
    return (
      <Modal
        show={this.state.show}
        onClose={this.onClose}
        className="sm-session-timeout-modal-container"
      >
        <ModalHeader header={t(COPY.SESSION_HEADER)} />
        <ModalBody>
          <Grid noBleeds>
            <Row>
              <Col xs={3}>
                <div className="sm-session-timeout-modal__iconstack">
                  <div className="sm-session-timeout-modal__iconstack-circle" />
                  <div className="sm-session-timeout-modal__iconstack-cover">
                    <Icon>(</Icon>
                  </div>
                </div>
              </Col>
              <Col xs={9}>
                <T
                  desc={COPY.TIME_LEFT_MSG}
                  values={{ minutesLeft: timeLeft }}
                  html
                />
              </Col>
            </Row>
          </Grid>
        </ModalBody>
        <ModalFooter>
          <Align placement="right">
            <Button color="secondary" onClick={this.onClose}>
              <T desc={COPY.CONTINUE_SESSION} />
            </Button>
          </Align>
        </ModalFooter>
      </Modal>
    );
  }
}

export default SessionTimeoutModal;
